import { InputBase } from '@mui/material';
import styled from 'styled-components';

export const MuiInputBase = InputBase;

/** Component to use when rendering a single line text in a grid, allowing for padding - also set the cell to be padCell: false */
export const GridTextInput = styled(MuiInputBase)`
	height: 100%;
	padding: 0.5em;
`;
